module.exports = __webpack_public_path__ + "static/img/topo.efc9e84.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/topo.jpg
// module id = 403
// module chunks = 1